<img
    class="animate-bounce"
    width="92"
    height="92"
    src="assets/images/Logo.svg"
>
<span *ngIf="message" class="p-10 text-xl font-normal text-zinc-800">
    {{ message }}
</span>